<style scoped>
.split-area {
  padding: 8px;
}
.drag-area {
  min-height: calc(100vh - 108px);
  border: 2px inset;
  padding: 4px;
}
.drag-item {
  margin-bottom: 8px;
}
.margin-item {
  margin: 8px;
}
.layout-app-bar {
  height: 40px;
}
.mu-slider-track {
  background-color: none;
}
.mu-slider-fill {
  background-color: none;
}
.fill-height {
  height: calc(100vh - 88px);
  overflow-y: auto;
  overflow-x: hidden;
}
.mobile-layout-item {
  margin: 4px 4px 0px 4px;
}
.media-page-bar {
  width: 100%;
  height: 30px;
  background-color: #FFFFFF00;
}
</style>

<template>
  <div v-loading="!(flagFetchedMedia && flagFetchedChannel)">
    <transition name="fade">
      <div v-if="flagFetchedMedia && flagFetchedChannel">
        <mu-appbar class="media-page-bar" z-depth="0">
          <mu-button icon slot="left" @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
          <mu-menu v-if="canEdit && computedComponents.length" slot="left">
            <mu-button small color="primary"><mu-icon value="add" />{{$t('layout.add.left')}}</mu-button>
            <mu-list slot="content">
              <mu-list-item button 
                v-for="item in computedComponents"
                @click="onCreateComponent('layoutLeft', item)" 
                >
                <mu-list-item-action>
                  <mu-icon :value="defaultComponent[item]['icon']"></mu-icon>
                </mu-list-item-action>
                <mu-list-item-title>{{$t('layout.name.' + item)}}</mu-list-item-title>
              </mu-list-item>
            </mu-list>
          </mu-menu>
          <mu-menu v-if="canEdit && computedComponents.length" slot="right">
            <mu-button small color="primary"><mu-icon value="add" />{{$t('layout.add.right')}}</mu-button>
            <mu-list slot="content">
              <mu-list-item button 
                v-for="item in computedComponents"
                @click="onCreateComponent('layoutRight', item)" 
                >
                <mu-list-item-action>
                  <mu-icon :value="defaultComponent[item]['icon']"></mu-icon>
                </mu-list-item-action>
                <mu-list-item-title>{{$t('layout.name.' + item)}}</mu-list-item-title>
              </mu-list-item>
            </mu-list>
          </mu-menu>
        </mu-appbar>
        <transition name="fade">
          <div>
            <rs-panes
              split-to="columns"
              :allow-resize="canEdit"
              class="full-width mobile-hide"
              units="percents"
              :min-size="0"
              :max-size="100"
              :size="modelColumn"
              @update:size="onUpdateLayoutColumn"
              >
              <div slot="firstPane" class="split-area fill-height">
                <draggable v-model="layoutLeft" :options="{ group:'layout', disabled: !canEdit, handle:'.drag-handle' }" :class="canEdit ? 'drag-area' : ''" @change="onUpdateLayout">
                  <div v-for="(element, index) in layoutLeft">
                    <div class="drag-item">
                      <mu-appbar class="full-width layout-app-bar" color="secondary" v-if="canEdit">
                        <mu-button icon slot="left" class="drag-handle">
                          <mu-icon value="open_with"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="left" @click="onToggleComponent('layoutLeft', index)">
                          <mu-icon :value="layoutLeft[index].enabled ? 'visibility' : 'visibility_off'"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="right" @click="onDeleteComponent('layoutLeft', index)">
                          <mu-icon value="delete"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="right" @click="onCollapseComponent('layoutLeft', index)">
                          <mu-icon :value="layoutLeft[index].collapsed ? 'expand_more' : 'expand_less'"></mu-icon>
                        </mu-button>
                        <small>{{$t('layout.name.' + element.component, element.component)}}</small>
                      </mu-appbar>
                      <layout-component
                        v-if="(isPreview && layoutLeft[index].enabled) || (!isPreview && !layoutLeft[index].collapsed)"
                        :component="layoutLeft[index].component"
                        :layout="layoutLeft[index].layout"
                        :mediaId="mediaId"
                        :media="media"
                        :channel="channel"
                        :flagReactionDetailShow="flagReactionDetailShow"
                        :flagPauseSwitch="flagPauseSwitch"
                        :timestamp="timestamp"
                        :timestampTrigger="timestampTrigger"
                        :currentTime="currentTime"
                        :overlays="overlays"
                        :isAdmin="isAdmin"
                        :adminUserIds="adminUserIds"
                        @onUpdateTime="onUpdateTime"
                        @onPause="onPause"
                        @onPlay="onPlay"
                        @onClickTimestamp="onClickTimestamp"
                        @onUpdateLayout="onUpdateModelLayout($event, 'layoutLeft', index)"
                        @onUpdateMedia="onUpdateMedia"
                        @onClickTag="onClickTag"
                        :tag="modelTag"
                        :tagTrigger="tagTrigger"
                        @onPlayerState="onPlayerState"
                        :playerState="playerState"
                        :startFrom="startFrom"
                        />
                    </div>
                  </div>
                  <mu-flex justify-content="center" v-if="canEdit && layoutLeft.length === 0">{{$t('layout.dragArea')}}</mu-flex>
                </draggable>
              </div>
              <div slot="secondPane" class="split-area fill-height">
                <draggable v-model="layoutRight" :options="{ group:'layout', disabled: !canEdit, handle:'.drag-handle' }" :class="canEdit ? 'drag-area' : ''" @change="onUpdateLayout">
                  <div v-for="(element, index) in layoutRight">
                    <div class="drag-item">
                      <mu-appbar class="full-width layout-app-bar" color="secondary" v-if="canEdit">
                        <mu-button icon slot="left" class="drag-handle">
                          <mu-icon value="open_with"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="left" @click="onToggleComponent('layoutRight', index)">
                          <mu-icon :value="layoutRight[index].enabled ? 'visibility' : 'visibility_off'"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="right" @click="onDeleteComponent('layoutRight', index)">
                          <mu-icon value="delete"></mu-icon>
                        </mu-button>
                        <mu-button icon slot="right" @click="onCollapseComponent('layoutRight', index)">
                          <mu-icon :value="layoutRight[index].collapsed ? 'expand_more' : 'expand_less'"></mu-icon>
                        </mu-button>
                        <small>{{$t('layout.name.' + element.component, element.component)}}</small>
                      </mu-appbar>
                      <layout-component
                        v-if="(isPreview && layoutRight[index].enabled) || (!isPreview && !layoutRight[index].collapsed)"
                        :component="layoutRight[index].component"
                        :layout="layoutRight[index].layout"
                        :mediaId="mediaId"
                        :media="media"
                        :channel="channel"
                        :flagReactionDetailShow="flagReactionDetailShow"
                        :flagPauseSwitch="flagPauseSwitch"
                        :timestamp="timestamp"
                        :timestampTrigger="timestampTrigger"
                        :currentTime="currentTime"
                        :overlays="overlays"
                        :isAdmin="isAdmin"
                        :adminUserIds="adminUserIds"
                        @onUpdateTime="onUpdateTime"
                        @onPause="onPause"
                        @onPlay="onPlay"
                        @onClickTimestamp="onClickTimestamp"
                        @onUpdateLayout="onUpdateModelLayout($event, 'layoutRight', index)"
                        @onUpdateMedia="onUpdateMedia"
                        @onClickTag="onClickTag"
                        :tag="modelTag"
                        :tagTrigger="tagTrigger"
                        @onPlayerState="onPlayerState"
                        :playerState="playerState"
                        :startFrom="startFrom"
                        />
                    </div>
                  </div>
                  <mu-flex justify-content="center" v-if="canEdit && layoutRight.length === 0">{{$t('layout.dragArea')}}</mu-flex>
                </draggable>
              </div>
            </rs-panes>
            <mu-row class="mobile-show">
              <mu-col span="12" v-for="(element, index) in layoutRight">
                <div class="mobile-layout-item">
                  <layout-component
                    v-if="(isPreview && layoutRight[index].enabled) || (!isPreview && !layoutRight[index].collapsed)"
                    :component="layoutRight[index].component"
                    :layout="layoutRight[index].layout"
                    :mediaId="mediaId"
                    :media="media"
                    :channel="channel"
                    :flagReactionDetailShow="flagReactionDetailShow"
                    :flagPauseSwitch="flagPauseSwitch"
                    :timestamp="timestamp"
                    :timestampTrigger="timestampTrigger"
                    :currentTime="currentTime"
                    :overlays="overlays"
                    :isAdmin="isAdmin"
                    :adminUserIds="adminUserIds"
                    @onUpdateTime="onUpdateTime"
                    @onPause="onPause"
                    @onPlay="onPlay"
                    @onClickTimestamp="onClickTimestamp"
                    @onUpdateMedia="onUpdateMedia"
                    @onClickTag="onClickTag"
                    :tag="modelTag"
                    :tagTrigger="tagTrigger"
                    @onPlayerState="onPlayerState"
                    :playerState="playerState"
                    :startFrom="startFrom"
                    />
                </div>
              </mu-col>
              <mu-col span="12" v-for="(element, index) in layoutLeft">
                <div class="mobile-layout-item">
                  <layout-component
                    v-if="(isPreview && layoutLeft[index].enabled) || (!isPreview && !layoutLeft[index].collapsed)"
                    :component="layoutLeft[index].component"
                    :layout="layoutLeft[index].layout"
                    :mediaId="mediaId"
                    :media="media"
                    :channel="channel"
                    :flagReactionDetailShow="flagReactionDetailShow"
                    :flagPauseSwitch="flagPauseSwitch"
                    :timestamp="timestamp"
                    :timestampTrigger="timestampTrigger"
                    :currentTime="currentTime"
                    :overlays="overlays"
                    :isAdmin="isAdmin"
                    :adminUserIds="adminUserIds"
                    @onUpdateTime="onUpdateTime"
                    @onPause="onPause"
                    @onPlay="onPlay"
                    @onClickTimestamp="onClickTimestamp"
                    @onUpdateMedia="onUpdateMedia"
                    @onClickTag="onClickTag"
                    :tag="modelTag"
                    :tagTrigger="tagTrigger"
                    @onPlayerState="onPlayerState"
                    :playerState="playerState"
                    :startFrom="startFrom"
                    />
                </div>
              </mu-col>
            </mu-row>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>

// Components
import LayoutComponent from '@/components/Layout/LayoutComponent.vue'

// Library
import draggable from 'vuedraggable'
import axios from "axios";

// Constant
import defaultComponent from '@/components/Layout/component.json'
import defaultLayout from '@/components/Layout/defaultLayout.json'

export default {
  name: 'MediaPage',
  components: {
    draggable,
    LayoutComponent
  },
  props: {
    mediaId: {
      type: String
    },
    startFrom: {
      type: String|Number
    }
  },
  data() {
    return {

      // Object
      channel: {}, // Channel object
      media: {}, // Media object
      comments: {}, // Comment list
      overlays: [],
      adminUserIds: [],
      layoutLeft: JSON.parse(JSON.stringify(defaultLayout['layoutLeft'])),
      layoutRight: JSON.parse(JSON.stringify(defaultLayout['layoutRight'])),
      modelColumn: 33,
      modelTag: {
        action: '',
        tagId: ''
      },

      // Flag
      flagFetchedChannel: false,
      flagFetchedMedia: false, // Boolean variable for status of media fetched
      flagFetchedMedias: false,
      flagFetchedOverlays: false, // Boolean variable for status of overlay fetched
      flagPauseSwitch: false, // Flag for indicating pause on video due to comment adding
      isAdmin: true,
      flagReactionDetailShow: false,

      // Video
      currentTime: 0, // Current time of video
      timestamp: 0, // Timestamp variable for storing new timestamp
      playerState: {},

      timeout: null,
      
      timestampTrigger: false,
      tagTrigger: false,
    }
  },
  computed: {
    // Flag
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    canEdit() {
      return !this.isPreview && this.isAdmin;
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    
    computedComponents() {
      var list = ["PlaylistPanel", "MediaPanel", "DiscussionTab", "QuizTab"];
      return list.filter(item => {
        var left = true;
        var right = true;
        if(this.layoutLeft.length > 0) {
          left = !this.layoutLeft.map(i => i.component).includes( item ); // Not in include in left
        }
        if(this.layoutRight.length > 0) {
          right = !this.layoutRight.map(i => i.component).includes( item ); // Not in include in right
        }
        return left && right;
      });
    },
    
    defaultComponent() {
      return defaultComponent;
    },
  },
  watch: {
    mediaId() {
      this.fetchMedia();
    },
  },
  created() {
    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        var result = response.data.data.result;
        if(result) {
          this.fetchMedia();
        } else {
          this.$router.go(-1);
        }
      });
    },
    fetchChannel(channel_id) {
      axios.get(this.$store.getters.urlApi + "channel/" + channel_id + '?all=1', {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.channel = response.data.data.channel;
        this.flagFetchedChannel = true;
      });
    },
    fetchMedia() {
      this.layoutLeft = JSON.parse(JSON.stringify(defaultLayout['layoutLeft']));
      this.layoutRight = JSON.parse(JSON.stringify(defaultLayout['layoutRight']));
      this.modelColumn = 45;
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.media = response.data.data.media;
        if(this.media.hasOwnProperty('layoutRight')) {
          this.layoutRight = this.media['layoutRight'];
        }
        if(this.media.hasOwnProperty('layoutLeft')) {
          this.layoutLeft = this.media['layoutLeft'];
        }
        if(this.media.hasOwnProperty('layoutColumn')) {
          this.modelColumn = this.media['layoutColumn']
        }
        this.flagFetchedMedia = true;
        if(Object.keys(this.channel).length === 0 || (this.channel && (this.channel._id !== this.media.channel_id))) {
          this.fetchChannel(this.media.channel_id);
          this.fetchAdmin();
        }
        this.fetchOverlays();
        this.fetchComments();
      }).catch(err => {
        this.$router.push({
          name: "NotFound",
          params: {
            url: this.$route.path
          }
        });
      });
    },
    fetchOverlays() {
      axios.get(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.overlays = response.data.data.overlays;
        this.flagFetchedOverlays = true;
      });
    },
    fetchComments() {
      axios.get(this.$store.getters.urlApi + "comment/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.comments = response.data.data.comments
      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.adminUserIds = response.data.data.admin.user_ids;
        this.isAdmin = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id) || this.$store.getters.isAdmin;
      });
    },

    // Event
    onClickBack() {
      this.$router.push({
        name: 'Channel',
        params: {
          channelId: this.channel._id
        }
      });
    },
    onUpdateTime(timeNew) {
      this.currentTime = timeNew;
    },
    onPause() {
      this.flagPauseSwitch = !this.flagPauseSwitch;
    },
    onPlay() {
      this.flagPauseSwitch = !this.flagPauseSwitch;
    },
    onClickTimestamp(time) {
      this.timestamp = time;
      this.timestampTrigger = !this.timestampTrigger;
    },
    onToggleComponent(name, index) {
      this.$data[name][index].enabled = !this.$data[name][index].enabled;
      this.onUpdateLayout();
    },
    onUpdateLayoutColumn(size) {
      this.modelColumn = size;
      this.onUpdateLayout();
    },
    onUpdateModelLayout(data, layout, index) {
      this.$data[layout][index].layout = data;
      this.onUpdateLayout();
    },
    onUpdateLayout() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        axios.put(this.$store.getters.urlApi + "media/" + this.media._id, {
          layoutLeft: this.layoutLeft,
          layoutRight: this.layoutRight,
          layoutColumn: this.modelColumn
          }, {
          headers: {
            token: this.$store.state.auth.token
          }
          }
        ).then(() => {

        });
      }, 500);
    },
    onCreateComponent(layout, component) {
      var data = JSON.parse(JSON.stringify(defaultComponent[component]));
      this.$data[layout].push(data);
      this.onUpdateLayout();
    },
    onDeleteComponent(layout, index) {
      var type = this.$data[layout][index].component;
      this.$data[layout].splice(index, 1);
      this.onUpdateLayout();
    },
    onCollapseComponent(layout, index) {
      if(this.$data[layout][index].hasOwnProperty('collapsed')) {
        if(this.$data[layout][index].collapsed)
          this.$set(this.$data[layout][index], 'collapsed', false);
        else
          this.$set(this.$data[layout][index], 'collapsed', true);
      } else {
        this.$set(this.$data[layout][index], 'collapsed', true);
      }
      this.onUpdateLayout();
    },
    onUpdateMedia(payload) {
      this.media[payload.index] = payload.data;
    },
    onPlayerState(payload) {
      this.playerState = payload;
    },
    onClickTag(payload) {
      this.modelTag = payload;
      this.tagTrigger = !this.tagTrigger;
    },
  },
}
</script>
